import { render } from "./template-modal.vue?vue&type=template&id=2d769d76"
import script from "./template-modal.vue?vue&type=script&lang=js"
export * from "./template-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__